import { render, staticRenderFns } from "./ClassroomMaterialTab.vue?vue&type=template&id=25bf324f&"
import script from "./ClassroomMaterialTab.vue?vue&type=script&lang=js&"
export * from "./ClassroomMaterialTab.vue?vue&type=script&lang=js&"
import style0 from "./ClassroomMaterialTab.vue?vue&type=style&index=0&id=25bf324f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports